import { LAYOUT_CONSTANTS } from "@src/constants";
import { BOTTOM_NAV_MOBILE_CSS } from "@src/constants/constant-css";
import { styled } from "@uhg-abyss/web/tools/styled";
import { DateInput } from "@uhg-abyss/web/ui/DateInput";
import { ModalDialog } from "@uhg-abyss/web/ui/ModalDialog";

/**
 * Common styled components shared across multiple pages
 */

export const FormSpacing = styled("div", {
  display: "flex",
  flexDirection: "column",
  gap: "$core.spacing.300",
});

export const HeadingDiv = styled("div", {
  fontWeight: 700,
  color: "$app.color.text.primary",
  marginBottom: "32px",
  variants: {
    device: {
      mobile: {
        fontSize: "28px",
        marginBottom: "16px",
        lineHeight: "36px",
      },
      tablet: {
        fontSize: "46px",
        lineHeight: "56px",
      },
      desktop: {
        fontSize: "52px",
        lineHeight: "64px",
      },
    },
  },
});

export const BodyText = styled("div", {
  fontSize: "18px",
  lineHeight: "24px",
  marginBottom: "32px",
  variants: {
    device: {
      mobile: {
        fontSize: "16px",
        lineHeight: "20px",
      },
    },
    mobileBrandColor: {
      true: {},
      false: {},
    },
  },
  compoundVariants: [
    {
      device: "mobile",
      mobileBrandColor: true,
      css: {
        color: "$app.color.text.primary",
      },
    },
  ],
  defaultVariants: {
    mobileBrandColor: false,
  },
});

export const StyledDateInput = styled(DateInput, {
  "& .abyss-date-input-elements-container": {
    position: "relative",
  },
  "& .abyss-date-input-elements-container::after": {
    content: '"mm/dd/yyyy"',
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    color: "$app.color.neutral.dark",
    pointerEvents: "none",
  },
  "& .abyss-date-input-elements-container:has(.abyss-date-input-input:focus)::after": {
    display: "none",
  },
  "& .abyss-date-input-elements-container:has(.abyss-date-input-input:not(:placeholder-shown))::after":
    {
      display: "none",
    },
  "& .abyss-date-input-input::placeholder": {
    color: "transparent",
  },
  ".abyss-date-input-format-text": {
    display: "none",
  },
});

export const StyledModalDialog = styled(ModalDialog, {
  "abyss-modal-base-header-container": {
    padding: "16px",
  },
  "abyss-modal-base-body": {
    padding: "16px",
  },
});

//Nav buttons on /refer & /get-started shared CSS - handles layout for both desktop and mobile
export const NavButtonsContainer = styled("div", {
  marginTop: "32px",
  width: "100%",
  maxWidth: LAYOUT_CONSTANTS.maxFormWidth,
  display: "flex",
  justifyContent: "space-between",
  padding: "0 8px",
  variants: {
    isMobile: {
      true: {
        justifyContent: "center",
        flexDirection: "column-reverse",
        maxWidth: "100%",
        ...BOTTOM_NAV_MOBILE_CSS,
      },
    },
  },
});
